import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// PDF do documento gerado no backend (mesmo HTML -> PDF usado na assinatura), para impressão.
export function useDocumentPdf() {
  const [isLoading, setLoading] = useState(false);

  const fetchPdf = useCallback((patientId, documentId) => {
    setLoading(true);
    return quarkusApi
      .get(`/patients/${patientId}/documents/${documentId}/pdf`, {
        headers: { Authorization: sessionStorage.getItem('token') },
        responseType: 'blob',
      })
      .finally(() => setLoading(false));
  }, []);

  return { fetchPdf, isLoading };
}
